<template>
  <div class="row d-flex align-items-center">
    <div class="col-xl-6 col-12">
      <div class="d-flex justify-content-xl-start justify-content-center mb-3">
        <div class="models-filters" :style="style1" @click="changeOrder('order', 1)">
          {{ translate.models }}
        </div>
        <div class="models-filters" :style="style2" @click="changeOrder('created_at', 2)">
          {{ translate.lastModels }}
        </div>
      </div>
    </div>
    <div class="col-xl-6 col-12">
      <vue-awesome-paginate
        class="justify-content-xl-end justify-content-sm-center mb-3"
        :modelValue="pageAtual"
        :total-items="paginations.total"
        :items-per-page="paginations.per_page"
        :max-pages-shown="isMobileBool ? 1 : 15"
        :on-click="onClickHandler"
        paginate-buttons-class="btn"
      />
    </div>
  </div>
  <div class="row align-items-center mt-2">
    <div v-for="model in arrayModels" class="col-lg-2" :key="model.id">
      <router-link
        :to="{
          name: 'ModelPageChild',
          params: {
            locale: locale,
            name: model.slug,
            complement: 'photo'
          }
        }"
      >
        <div class="card-pagination pr-3 pb-4">
          <img :src="`${model.cover}`" :alt="model.title" width="227" height="168" />
          <div class="card-body d-flex flex-column align-items-center">
            <h5 class="card-title my-3">{{ model.title }}</h5>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed, onMounted, ref } from 'vue'
  import { localeStore } from '../../stores/locale'
  import modelsTradutor from '../../tradutors/models'
  import { isMobile } from '../../views/shared/utils/mobile'
import api from '../../api'

  interface Model {
    id: number
    title: string
    slug: string
    cover: string
  }

  interface Pagination {
    total: number
    per_page: number
    data: Model[]
    current_page: number
  }
  const props = defineProps({
    models: {
      type: Object as () => Pagination,
      required: true
    }
  })

  const storeLocale = localeStore()
  const locale = computed(() => storeLocale.locale)

  const translate = computed(() => {
    if (storeLocale.locale === 'pt-br') {
      return modelsTradutor.portugues
    } else {
      return modelsTradutor.ingles
    }
  })

  const isMobileBool = computed(() => isMobile())
  const pageAtual = ref(1)
  const arrayModels = ref([])
  const paginations = ref({
    total: 1,
    per_page: 1
  })
  const orderBy = ref('order')
  const style1 = ref({ fontWeight: 'bold' })
  const style2 = ref({ fontWeight: 'normal' })

  onMounted(() => {
    arrayModels.value = props.models.data
    paginations.value = props.models
    pageAtual.value = props.models.current_page
  })

  async function onClickHandler(page: number) {
    pageAtual.value = page
    await getNewPage(page)
  }
  async function getNewPage(page) {
    api.get('v1/modelos/getAllModels?order=' + orderBy.value + '&page=' + page).then(({ data }) => {
      const { modelsArray } = data
      paginations.value = modelsArray
      arrayModels.value = modelsArray.data
    })
  }
  async function changeOrder(order, link) {
    orderBy.value = order
    onClickHandler(1)
    ;(style1.value = { fontWeight: 'bold' }), (style2.value = { fontWeight: 'normal' })
    if (link == 2) {
      ;(style2.value = { fontWeight: 'bold' }), (style1.value = { fontWeight: 'normal' })
    }
  }
</script>

<style scoped lang="css">
  .card-title {
    height: 19px;
    color: #666666;
    font-family: 'Exo-2';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
    text-align: center;
  }

  .card-pagination img {
    width: 100%;
    object-fit: cover;
    height: auto;
  }

  .card-pagination {
    background-color: transparent;
    cursor: pointer;
  }

  .models-filters {
    font-family: 'Bebas-Neue';
    font-size: 20px;
    font-weight: 300;
    padding: 0px 10px;
    border-left: 1px solid #666666;
    border-right: 1px solid #666666;
    cursor: pointer;
  }

  .col-lg-2 {
    width: 20%;
  }

  /* regras mobile 769vp */
  @media screen and (max-width: 769px) {
    .col-lg-2 {
      width: 50%;
    }
  }
</style>
